<div fxLayout="row" class="top-bar" ngClass.gt-md="mlp-15">
    <div class="top-line">
        <a href="https://www.iaea.org" target="_blank" rel="noopener noreferrer">IAEA</a>
        <a href="https://nucleus.iaea.org/Pages/default.aspx" target="_blank" rel="noopener noreferrer">NUCLEUS</a>
    </div>
</div>
<div ngClass.xs="xs" ngClass.sm="sm" fxLayout="row" fxLayoutAlign="start center" class="toolbar-light" *ngIf="!fullscreen">
    <div ngClass.xs="xs" ngClass.sm="sm" fxFlex fxLayout="row" fxLayoutAlign="space-between center" ngClass.gt-md="mlp-15 w-70">
        <div fxFlex.gt-md="20" fxLayout="row" fxLayoutAlign="start center">
            <a ngClass.xs="xs" ngClass.sm="sm" class="navbar-brand d-flex align-items-center iaea-img" href="javascript:location.href=location.origin">
                <img ngClass.xs="xs" ngClass.sm="sm" src="../../../assets/images/iaea-logo-blue.svg" alt="IAEA Logo" class="" />
                <span class="h5 mb-0 border-start border-1 pl-3 border-primary text-uppercase text-primary fw-bold">MARIS</span>
                <span fxHide.xs class="navbar-brand-subtitle img-title"
                    >Marine Radioactivity <br />
                    Information System</span
                >
            </a>
        </div>
        <nav fxFlex.gt-md="80" class="navbar" fxLayout="row" fxLayoutGap="20px">
            <div class="main_nav" fxHide.lt-md fxShow.gt-sm>
                <ul fxLayout="row" fxLayoutAlign="end center" class="navbar-nav">
                    <li class="nav-item">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/home">Home</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/explore">Explore</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/datasets">Datasets</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/faq">FAQ</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/links">Links</a>
                    </li>
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" data-toggle="dropdown"> Help </a>
                        <ul class="dropdown-menu">
                            <li *ngFor="let item of helpLinks$ | async">
                                <a [routerLinkActive]="['active']" class="dropdown-menu-links" routerLink="/help/{{ item.contentId }}">{{ item.title }}</a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item get-involved">
                        <a [routerLinkActive]="['active']" class="nav-link" routerLink="/get-involved"> Get Involved </a>
                    </li>
                </ul>
            </div>
            <!-- navbar-collapse.// -->
            <div class="hamburger-icon" ngClass.xs="xs" ngClass.sm="sm" (click)="toggleMenu()" fxHide.gt-sm>
                <div class="bar"></div>
                <div class="bar"></div>
                <div class="bar"></div>
            </div>
            <div [ngClass]="{ 'menu-open': isMenuOpen }" fxLayout="row" fxFlex="100" *ngIf="!fullscreen">
                <div class="hamburger_nav" fxHide.gt-sm fxShow.lt-md>
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/home">Home</a>
                        </li>
                        <li class="nav-item">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/explore">Explore</a>
                        </li>
                        <li class="nav-item">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/datasets">Datasets</a>
                        </li>
                        <li class="nav-item">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/faq">FAQ</a>
                        </li>
                        <li class="nav-item">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/links">Links</a>
                        </li>
                        <li fxHide.lt-md class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle" data-toggle="dropdown"> Help </a>
                            <ul class="dropdown-menu">
                                <li *ngFor="let item of helpLinks$ | async">
                                    <a [routerLinkActive]="['active']" class="dropdown-menu-links" routerLink="/help/{{ item.contentId }}">{{ item.title }}</a>
                                </li>
                            </ul>
                        </li>
                        <li fxHide.gt-sm class="nav-item" *ngFor="let item of helpLinks$ | async">
                            <a [routerLinkActive]="['active']" class="nav-link" routerLink="/help/{{ item.contentId }}">{{ item.title }}</a>
                        </li>
                        <li class="nav-item">
                            <a class="btn btn-primary" (click)="openDialog()">Get Involved</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</div>

<div id="container" *ngIf="showDialog" class="display-dialog">
    <div class="dialog">
        <div *ngComponentOutlet="activeComponent"></div>
    </div>
</div>
